import React from "react";
import { ChevronsLeftRight } from "lucide-react";
import { makeStyles, TableCell } from "@material-ui/core";

interface SortedTableCellProps {
    name: string;
    field: string;
    sortBy: string;
    changeSort: (field: string) => void;
}

const useStyles = makeStyles(() => ({
    tableHeaderCell: {
        color: "#fff", fontWeight: 500, fontSize: 16,
        background: "#74747426",
        borderRight: "1px solid #74747426",
        borderBottom: 0,
        lineHeight: "normal",
        height: "auto",
        verticalAlign: "center",

        "&.active": {
            color: "#FF78AA",
        },
        "& .MuiOutlinedInput-inputAdornedStart": {
            background: "transparent",
            border: 0
        }
    },
}))

const SortedTableCell: React.FC<SortedTableCellProps> = ({ name, field, sortBy, changeSort }) => {
    const classes = useStyles();

    return (
        <TableCell
            className={classes.tableHeaderCell + (sortBy === field ? " active" : "")}
            onClick={() => changeSort(field)}
            style={{ cursor: "pointer" }}
        >
            <div style={{ width: "max-content" }}>
                {name}
                <span>
                    <ChevronsLeftRight
                        size={16}
                        color={sortBy === field ? "#FF78AA" : "#FFFFFF"}
                        style={{
                            transform: "rotate(90deg)",
                            strokeWidth: 2,
                            position: "relative",
                            top: 2,
                            marginLeft: 4,
                        }}
                    />
                </span>
            </div>
        </TableCell>
    );
};

export default SortedTableCell;